/* eslint-disable */
import moment from 'moment'

// 检查手机格式
const checkPhone = (value) => {
    return /^1[3456789]\d{9}$/.test(value)
}

// 去掉前后空格
const trim = (str) => {
    str = str.replace(/\s+/g, '')
    return str
}

// 去掉前后空格
const trimAll = (str) => {
    str = str.replace(/\s/g, '')
    return str
}

// 获取随机数
const getNumber = () => {
    return moment().format('YYYYMMDDHHmmssS')
}

// 密码中必须包含字母（不区分大小写）、数字，至少6个字符，最多16个字符；
const checkPassword = (str) => {
    let chPattern = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{6,16}')
    return chPattern.test(str)
}

// 获取字符串长度
const getStringLength = (str) => {
    let len = 0;
    str = str.replace(/\s*/g, '');
    for (let i = 0; i < str.length; i++) {
        let a = str.charAt(i);
        if (a.match(/[^\x00-\xff]/gi) != null) {
            //\x00-\xff→GBK双字节编码范围
            len += 2;
        } else {
            len += 1;
        }
    }
    return len;
}


// 格式化时间 转为自己想要的格式

const Moment = (date, str) => {
    if (date !== '') {
        return moment(date).format(str);
    } else {
        return moment().format(str);
    }
}

const getObjectFromArrayById = (id, array) => {
    return array.find(item => item.id === id)
}

export default {
    install(Vue) {
        Vue.prototype.checkPhone = checkPhone
        Vue.prototype.trim = trim
        Vue.prototype.trimAll = trimAll
        Vue.prototype.checkPassword = checkPassword
        Vue.prototype.getNumber = getNumber
        Vue.prototype.getStringLength = getStringLength
        Vue.prototype.Moment = Moment
        Vue.prototype.getObjectFromArrayById = getObjectFromArrayById
    }
}
